export const API_URL = import.meta.env.VITE_REACT_APP_API_URL;
export const FLOWCHART_API_URL = import.meta.env
  .VITE_REACT_APP_FLOWCHART_API_URL;
export const FULL_STORY_ORG_ID = import.meta.env
  .VITE_REACT_APP_FULL_STORY_ORG_ID;
export const API_ENV = import.meta.env.VITE_REACT_APP_ENV;
export const DSN_SENTRY = import.meta.env.VITE_REACT_APP_DSN_SENTRY;
export const JWT_SECRET = '123456';
export const LOGIN_PATH = import.meta.env.VITE_REACT_APP_LOGIN_PATH;
export const PUSHER_KEY = import.meta.env.VITE_REACT_APP_PUSHER_ENV;
export const DASHBOARD_ENABLED = import.meta.env
  .VITE_REACT_APP_DASHBOARD_ENABALED;
export const IS_PROD = import.meta.env.VITE_REACT_APP_IS_PROD;
export const PUBLIC_POSTHOG_KEY = import.meta.env
  .VITE_REACT_APP_PUBLIC_POSTHOG_KEY;
export const PUBLIC_POSTHOG_HOST = import.meta.env
  .VITE_REACT_APP_PUBLIC_POSTHOG_HOST;
export const FS_ORGID = import.meta.env.VITE_REACT_APP_PUBLIC_FULLSTORY_ORGID;
export const GOOGLE_CLIENT_ID = import.meta.env
  .VITE_REACT_APP_PUBLIC_GOOGLE_CLIENT_ID;
export const PUSHER_CLUSTER = import.meta.env.VITE_REACT_APP_PUSHER_CLUSTER;
export const APP_ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT;
export const SENTRY_ORG_SLUG = import.meta.env.VITE_SENTRY_ORG_SLUG;
export const INTERCOM_APP_ID = import.meta.env.VITE_APP_INTERCOM_APP_ID;
